import React from "react";

import { DeleteWithDependenciesModal } from "src/agents/modals/DeleteWithDependenciesModal";
import {
  useDraftFlowsReferencingAgent,
  usePublishedFlowsReferencingAgent,
} from "src/agents/queries/flowReferences";
import { Agent } from "src/agents/types";

type DeleteAgentModalProps = {
  isOpen: boolean;
  agent: Agent | undefined;
  workspaceId: string;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
};

export const DeleteAgentModal: React.FC<DeleteAgentModalProps> = ({
  isOpen,
  agent,
  workspaceId,
  onClose,
  onConfirm,
}) => {
  const queryEnabled = isOpen && !!agent;

  const { data: publishedFlows, isLoading: isLoadingPublished } =
    usePublishedFlowsReferencingAgent(workspaceId, agent?.id ?? "", {
      enabled: queryEnabled,
    });
  const { data: draftFlows, isLoading: isLoadingDraft } =
    useDraftFlowsReferencingAgent(workspaceId, agent?.id ?? "", {
      enabled: queryEnabled,
    });

  return (
    <DeleteWithDependenciesModal
      blockingDescription="This Agent cannot be deleted because it is used by published versions of other resources:"
      blockingMessage="Please remove these connections before deleting this Agent."
      blockingTitle={`Cannot delete "${agent?.name}"`}
      confirmationDataLoc="delete-agent-confirmation"
      confirmationDescription="Are you sure you want to delete this Agent? This action cannot be undone."
      confirmationTitle={`Delete "${agent?.name}"`}
      draftFlows={draftFlows}
      draftWarningMessage="Deleting this Agent may break the connections listed below:"
      isLoading={isLoadingPublished || isLoadingDraft}
      isOpen={isOpen}
      publishedFlows={publishedFlows}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
